// extracted by mini-css-extract-plugin
module.exports = {"container":"after-empty-cart_container__FZINy","desktopWrapper":"after-empty-cart_desktopWrapper__9bgLQ","mobileWrapper":"after-empty-cart_mobileWrapper__52BV_"};